import React, { useState, Suspense } from "react";

// Lazy load Layer 3 ของแต่ละ service
const RefinementS = React.lazy(() => import("./PackageArtwork/RefinementS"));
const RefinementM = React.lazy(() => import("./PackageArtwork/RefinementM"));

export default function PackageArtwork({
  onBack,
  selectedCustomer,
  selectedUserId,
  userId, // ให้โพรพเหมือน MsgShortcut.jsx
}) {
  const [selectedService, setSelectedService] = useState(null);

  // เมนูตามลิสต์ที่ให้มา
  const services = [
    "Facial Refinement S",
    "Facial Refinement M-XXL",
  ];

  // ให้ component ตามชื่อ service
  const renderSelected = () => {
    switch (selectedService) {
      case "Facial Refinement S":
        return (
          <RefinementS
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Facial Refinement M-XXL":
        return (
          <RefinementM
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
          );
      default:
        return null;
    }
  };

  return (
    <div className="pt-0 px-4 pb-4">
      {!selectedService ? (
        <>
          <div className="flex items-center gap-3 mt-[-2px] mb-4">
            <h3 className="text-lg font-semibold">Set Package Artwork</h3>
            <button
              onClick={onBack}
              className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition"
            >
              ← Back to Main Asset
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {services.map((s) => (
              <button
                key={s}
                onClick={() => setSelectedService(s)}
                className="w-full border rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-50 transition text-left"
              >
                {s}
              </button>
            ))}
          </div>
        </>
      ) : (
        <Suspense fallback={<div className="p-4 text-sm text-gray-500">Loading…</div>}>
          {renderSelected()}
        </Suspense>
      )}
    </div>
  );
}
